module.exports = __webpack_public_path__ + "static/media/09_vozdobrasil_mobile.c912f45f.jpg";